import {
  BellOutlined,
  GiftOutlined,
  MailOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import { type MenuItemType } from 'antd/es/menu/interface';
import React from 'react';

import Link from './link';

function SidebarCRM(): React.ReactElement {
  const menuItems: MenuItemType[] = [
    {
      key: 'customers',
      icon: <UserOutlined />,
      label: <Link to="/crm/customers" label="Customers" />,
    },
    {
      key: 'watchdog',
      icon: <BellOutlined />,
      label: <Link to="/crm/watchdog" label="Watchdog" />,
    },
    {
      key: 'gift-registries',
      icon: <GiftOutlined />,
      label: <Link to="/crm/gift-registries" label="Gift Registry" />,
    },
    {
      key: 'marketing-consent-campaign',
      icon: <MailOutlined />,
      label: (
        <Link to="/crm/marketing-consent-campaign" label="Marketing Consent" />
      ),
    },
  ];

  return <Menu items={menuItems} />;
}

export default SidebarCRM;
